<div class="modal-body">
  <div id="modal-header-wrapper">
    <h2 id="title-text">{{ title }}</h2>
    <p *ngIf="subtitle" id="subtitle-text" [innerHTML]="subtitle"></p>

    <ng-container *ngIf="!loadingPaymentMethods else paymentMethodsSpinner">
      <msd-payment-informations-edit
        *ngFor="let paymentMethod of paymentMethods"
        [withModifyButton]="false"
        [paymentMethod]="paymentMethod"
        [loading]="loadingPaymentMethods">
      </msd-payment-informations-edit>
    </ng-container>
    <ng-template #paymentMethodsSpinner>
      <ngx-inner-loading [emptyDescription]="'Aucun mode de paiement...'"
                         [empty]="!paymentMethods || paymentMethods.length === 0"
                         [loading]="loadingPaymentMethods"
                         [loadingDescription]="'Chargement de votre mode de paiement'"
                         [error]="!!errorPaymentMethods"
                         [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'"
                         class="flex-center" style="height: 120px">
      </ngx-inner-loading>
    </ng-template>

    <div id="coupon-form" class="form-field">
      <label>Code promotion</label>
      <input [(ngModel)]="coupon" type="text" class="form-control" id="coupon-input">
    </div>

  </div>
  <div class="modal-footer">
    <button id="cancel-button" (click)="hideModal(); cancel.emit();" type="button"
            class="btn btn-outline-primary btn-outline text-only">
      Annuler
    </button>

    <button id="validate-button" [disabled]="loadingPaymentMethods" (click)="hideModal(); validate.emit(coupon)" type="button"
            class="btn btn-primary btn-gradient">
      Valider
    </button>
  </div>
</div>
